var map = {
	"./bsc_s.png": 3143,
	"./dex-view_s.png": 8572,
	"./dex_s.png": 6301,
	"./eth_s.png": 7914,
	"./honey_s.png": 8897,
	"./pan_s.png": 9560,
	"./pink_s.png": 9758,
	"./poo_s.png": 4187,
	"./screener_s.png": 772,
	"./uniswap_s.png": 9135
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4521;